import { Unsubscribe as FirebaseUnsubscribe, User as FirebaseUser, getAuth } from 'firebase/auth';
import { useSyncExternalStore } from 'react';

export type { FirebaseUser };

const subscribeToFirebaseAuthStateChange = (nextFn: () => void): FirebaseUnsubscribe => {
  return getAuth().onAuthStateChanged(nextFn);
};

const getFirebaseUserSnapshot = (): FirebaseUser | null => getAuth().currentUser;

const getServerSideSnapshot = () => null;

export const useFirebaseUser = () => {
  return useSyncExternalStore(subscribeToFirebaseAuthStateChange, getFirebaseUserSnapshot, getServerSideSnapshot);
};
